<div fxLayout="column">
  <div fxFlex="30">
    <h3>{{title}}</h3>
  </div>
  <div fxFlex="60">
    <p class="description">{{description}}</p>
  </div>
</div>